import { createRouter, createWebHistory } from "vue-router";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { doc, getDoc, getFirestore } from "firebase/firestore";
import store from "@/store";
import HomeView from "../views/HomeView.vue";
import DashboardView from "../views/DashboardView.vue";
import MarketplaceView from "../views/MarketplaceView.vue";
import MarketplaceHighlightsView from "../views/MarketplaceHighlightsView.vue";
import NetMeteringSchemeView from "../views/NetMeteringSchemeView.vue";
import CommunityBatteryView from "../views/CommunityBatteryView.vue";
import SystemVitalsView from "../views/SystemVitalsView.vue";
import SignupView from "../views/SignupView.vue";
import LoginView from "../views/LoginView.vue";
import MaintenanceView from "../views/MaintenanceView.vue";
import ContactView from "../views/ContactView.vue";
import ReportBugView from "../views/ReportBugView.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: DashboardView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/marketplace",
        name: "marketplace",
        component: MarketplaceView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/marketplace-highlights",
        name: "marketplace-highlights",
        component: MarketplaceHighlightsView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/community-battery",
        name: "community-battery",
        component: CommunityBatteryView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/net-metering-scheme",
        name: "net-metering-scheme",
        component: NetMeteringSchemeView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/system-vitals",
        name: "system-vitals",
        component: SystemVitalsView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/signup",
        name: "signup",
        component: SignupView,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/login",
        name: "login",
        component: LoginView,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/request-maintenance",
        name: "request-maintenance",
        component: MaintenanceView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/contact",
        name: "contact",
        component: ContactView,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/report-bug",
        name: "report-bug",
        component: ReportBugView,
        meta: {
            requiresAuth: true,
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

// const getCurrentUser = () => {
//     console.log("Step 2");
//     return new Promise((resolve, reject) => {
//         console.log("Step 3");
//         const removeListener = onAuthStateChanged(getAuth(), (user) => {
//             console.log("Step 4");
//             if (user) {
//                 console.log("Step 5");
//                 // User is signed in
//                 removeListener();
//                 if (store.state.user === null) {
//                     // fetch user from DB and update state

//                     const docRef = doc(getFirestore(), "users", user.uid);
//                     getDoc(docRef)
//                         .then((doc) => {
//                             store.dispatch("setCurrentUser", doc.data());
//                         })
//                         .catch(() => {
//                             console.log("Failed to retrieve logged in user!");
//                         });
//                 }
//                 resolve(user);
//             } else {
//                 console.log("Step 6");
//                 // User is signed out
//                 router.push("/signup");
//                 reject;
//             }
//         });
//     });
// };

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.state.user === null) {
            next({ name: "login" });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
